// Simple global pub/sub for TD components
// Provides TD_PUBLISH(channel, data) and TD_SUBSCRIBE(channel, callback)
// Returns an unsubscribe function from TD_SUBSCRIBE

(function () {
  if (
    Object.prototype.hasOwnProperty.call(window, "TD_PUBLISH") &&
    Object.prototype.hasOwnProperty.call(window, "TD_SUBSCRIBE")
  )
    return;

  const bus = new EventTarget();

  /**
   * Publish an event with optional detail payload
   * @param {string} channel
   * @param {any} detail
   */
  function TD_PUBLISH(channel, detail) {
    try {
      bus.dispatchEvent(new CustomEvent(channel, { detail }));
    } catch (e) {
      // no-op
    }
  }

  /**
   * Subscribe to an event channel
   * @param {string} channel
   * @param {(detail:any)=>void} callback
   * @returns {() => void} unsubscribe
   */
  function TD_SUBSCRIBE(channel, callback) {
    /** @param {CustomEvent} e */
    const handler = (e) => {
      try {
        callback(e.detail);
      } catch (err) {
        // no-op
      }
    };
    bus.addEventListener(channel, handler);
    return () => bus.removeEventListener(channel, handler);
  }

  window.TD_PUBLISH = TD_PUBLISH;
  window.TD_SUBSCRIBE = TD_SUBSCRIBE;
})();


